import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const AssociatedCasesResultRow = ({ row }) => (
  <Fragment>
    <a href={`/filings/search-court-filings?search_type=case_no&search_term=${row.associated_case.case_no}`}>
      {row.associated_case.case_no}
    </a>
    <br />
    <span dangerouslySetInnerHTML={{ __html: row.associated_case.case_name }} />
    <br />
    <em>({row.associated_case.case_type})</em>
  </Fragment>
);

AssociatedCasesResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default AssociatedCasesResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/AssociatedCasesResultRow.jsx